export default "__VITE_ASSET__169ef723__"